import { render, staticRenderFns } from "./csptest.vue?vue&type=template&id=9bce8442&scoped=true"
import script from "./csptest.vue?vue&type=script&lang=js"
export * from "./csptest.vue?vue&type=script&lang=js"
import style0 from "./csptest.vue?vue&type=style&index=0&id=9bce8442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bce8442",
  null
  
)

export default component.exports